import Vue from "vue";
import Router from "vue-router";

import {importRoutes} from "@/utils";
// search the components directory (and subdirectories) for .vue components
const {
    MainPage,
    LegalPage
} = importRoutes();

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: "/",
            name: "Main",
            component: MainPage,
            meta: {
                title: "Federal Reserve Thrift Plan | Morningstar"
            }
        },
        {
            path: "/legal",
            name: "Legal",
            component: LegalPage,
            meta: {
                title: "Federal Reserve Thrift Plan | Morningstar"
            }
        },
        {
            path: "/MorningstarLifetimeIndexFunds",
            name: "MStarMain",
            component: MainPage,
            meta: {
                title: "Morningstar Lifetime Index Funds"
            }
        },
        {
            path: "/MorningstarLifetimeIndexFunds/legal",
            name: "MStarLegal",
            component: LegalPage,
            meta: {
                title: "Morningstar Lifetime Index Funds"
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.title);

    const nearestWithMeta = to.matched
        .slice()
        .reverse()
        .find(r => r.meta && r.meta.metaTags);

    if (nearestWithTitle) {
        document.title = nearestWithTitle.meta.title;
    }

    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
        el => el.parentNode.removeChild(el)
    );

    if (!nearestWithMeta) {
        return next();
    }

    nearestWithMeta.meta.metaTags
        .map(tagDef => {
            const tag = document.createElement("meta");
            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, tagDef[key]);
            });
            tag.setAttribute("data-vue-router-controlled", "");
            return tag;
        })
        .forEach(tag => document.head.appendChild(tag));
    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js